import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-employee',
  templateUrl: './edit-employee.component.html',
  styleUrls: ['./edit-employee.component.scss']
})
export class EditEmployeeComponent implements OnInit {

  @ViewChild('imageInput') imageInput!: ElementRef;
  @ViewChild('editForm') editForm: any;

  employeeId: string | null = null;
  cities: any[] = [];
  
  product: any = {
    name: '',
    email: '',
    nationality_id: '',
    phone: '',
    identity_number: '',
    job_title_id: '',
    city_id: '',
    image: null,
  };

  jobTitles: any[] = [];
  currentLang: string | undefined;
  countries: any[] = [];
  isLoading: boolean = false;
  selectedFile: File | null = null;
  originalImage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,  
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentLang = localStorage.getItem('currentLang') || 'ar';
    this.employeeId = this.route.snapshot.paramMap.get('id');
    
    
    
    if (this.employeeId) {
      this.loadEmployee(this.employeeId);
       this.fetchJobTitles();
      this.getCountries();
    }
   
  }
  loadEmployee(id: string): void {
    this.isLoading = true;
    
    this.apiService.getEmployeeById(id).subscribe({
      next: (res: any) => {
        if (res?.data) {
          // حفظ البيانات الأصلية مؤقتاً
          const employeeData = res.data;
          
          // تعيين القيم الأساسية
          this.product = {
            name: employeeData.name || '',
            email: employeeData.email || '',
            phone: employeeData.phone || '',
            identity_number: employeeData.identity_number || '',
            job_title_id: employeeData.job_title_id?.toString() || employeeData.job_title?.id?.toString() || '',
            image: employeeData.image || null,
          };

          // 🔥 معالجة الجنسية بشكل صحيح
          if (employeeData.nationality_id) {
            this.product.nationality_id = employeeData.nationality_id.toString();
          } else if (employeeData.nationality?.id) {
            this.product.nationality_id = employeeData.nationality.id.toString();
          } else {
            this.product.nationality_id = employeeData.nationality?.toString() || '';
          }

          // 🔥 معالجة المدينة بشكل صحيح
          if (employeeData.city_id) {
            this.product.city_id = employeeData.city_id.toString();
          } else if (employeeData.city?.id) {
            this.product.city_id = employeeData.city.id.toString();
          } else {
            this.product.city_id = employeeData.city?.toString() || '';
          }

          console.log('📋 Employee data loaded:', {
            name: this.product.name,
            nationality_id: this.product.nationality_id,
            city_id: this.product.city_id,
            job_title_id: this.product.job_title_id
          });

          this.originalImage = employeeData.image;

          // 🔥 تحميل المدن بعد تعيين الجنسية
          setTimeout(() => {
            if (this.product.nationality_id) {
              this.getCities(this.product.nationality_id);
            }
          }, 300);
        }

        this.isLoading = false;
      },
      error: (err) => {
        console.log('Error loading employee:', err);
        this.isLoading = false;
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_employee'));
      }
    });
  }

  // getCountries(): void {
  //   this.apiService.getCountriesM().subscribe({ 
  //     next: (response: any) => { 
  //       this.countries = response.data || [];
  //       console.log('🌍 Countries loaded:', this.countries);
        
  //       // بعد تحميل الدول، تحميل بيانات الموظف إذا كانت الجنسية معروفة
  //       if (this.product.nationality_id && this.employeeId) {
  //         // لا داعي لاستدعاء loadEmployee هنا مرة أخرى
  //       }
  //     }, 
  //     error: (err) => { 
  //       console.log('Error fetching countries:', err);
  //       this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
  //     }
  //   });
  // }

  onNationalityChange(): void {
    console.log('🔄 Nationality changed to:', this.product.nationality_id);
    this.product.city_id = ''; // إعادة تعيين المدينة
    if (this.product.nationality_id) {
      this.getCities(this.product.nationality_id);
    } else {
      this.cities = [];
    }
  }


  getCities(nationalityId: string): void {
  console.log('🏙️ Fetching cities for country:', nationalityId);

  this.apiService.getCitiesById(nationalityId).subscribe({
    next: (response: any) => {
      // ✅ Convert SINGLE object → ARRAY if needed
      if (!response.data) {
        this.cities = [];
      } else if (Array.isArray(response.data)) {
        this.cities = response.data;
      } else {
        this.cities = [response.data];
      }

      console.log('🏙️ Cities loaded:', this.cities);

      // ✅ Auto select the city if it's already set
      if (this.product.city_id) {
        const cityExists = this.cities.find(c => c.id.toString() === this.product.city_id.toString());
        if (!cityExists) {
          // If not found, reset or select first city
          this.product.city_id = this.cities.length > 0 ? this.cities[0].id.toString() : '';
        }
      }
    },
    error: (err) => {
      console.log('Error fetching cities:', err);
      this.cities = [];
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_cities'));
    }
  });
}


  // 🔥 دالة جديدة للتأكد من تعيين المدينة بشكل صحيح
  ensureCityIsSet(): void {
    if (this.product.city_id && this.cities.length > 0) {
      const cityExists = this.cities.find((c: any) => c.id == this.product.city_id);
      if (!cityExists) {
        console.warn('City not found in list, resetting city');
        this.product.city_id = '';
      }
    }
  }

getCountries(): void {
  this.apiService.getCountriesM().subscribe({
    next: (response: any) => {
    // بعد تحميل الدول
this.countries = response.data || [];
if (this.product.nationality_id) {
  const tempNationality = this.product.nationality_id;
  this.product.nationality_id = '';
  setTimeout(() => {
    this.product.nationality_id = tempNationality;

    // بعد اختيار الدولة، حمل المدن
    if (this.product.nationality_id) {
      this.getCities(this.product.nationality_id);
    }
  }, 0);
}
    },
    error: (err) => {
      console.log('error in fetching', err);
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
    }
  });
}


  // 🔥 دالة جديدة للتأكد من تعيين الجنسية بشكل صحيح
  ensureNationalityIsSet(): void {
    if (this.product.nationality_id && this.countries.length > 0) {
      const countryExists = this.countries.find((c: any) => c.id == this.product.nationality_id);
      if (!countryExists) {
        console.warn('Country not found in list, resetting nationality');
        this.product.nationality_id = '';
        this.cities = [];
        this.product.city_id = '';
      }
    }
  }

  fetchJobTitles(): void {
    this.apiService.getJobTitles().subscribe({
      next: (res) => (this.jobTitles = res),
      error: () => this.toastr.error('Failed to load job titles')
    });
  }

  

  // دالة معززة لتحميل المدن بعد تحميل الموظف
  loadCitiesForEmployee(): void {
    if (this.product.nationality_id) {
      console.log('🔍 Loading cities for nationality:', this.product.nationality_id);
      
      this.apiService.getCitiesById(this.product.nationality_id).subscribe({ 
        next: (response: any) => { 
          this.cities = response.data || [];
          console.log('✅ Cities loaded for employee:', this.cities);
          
          // بعد تحميل المدن، تأكد من اختيار المدينة الصحيحة
          if (this.product.city_id && this.cities.length > 0) {
            const cityExists = this.cities.find((c: any) => c.id.toString() === this.product.city_id.toString());
            if (cityExists) {
              console.log('✅ City found and selected:', cityExists.name);
            } else {
              console.warn('⚠️ City not found in list:', this.product.city_id);
              // إذا لم توجد المدينة، يمكنك اختيار أول مدينة كقيمة افتراضية
              // this.product.city_id = this.cities[0]?.id || '';
            }
          }
        }, 
        error: (err) => { 
          console.log('Error loading cities:', err);
          this.cities = [];
        }
      });
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.selectedFile = file;
    
    if (file) {
      if (!file.type.startsWith('image/')) {
        this.toastr.error(this.translate.instant('VALIDATION.invalid_image_type'));
        this.resetImageInput();
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        this.toastr.error(this.translate.instant('VALIDATION.image_size_exceeded'));
        this.resetImageInput();
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.product.image = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(): void {
    this.selectedFile = null;
    this.product.image = null;
    this.resetImageInput();
  }

  private resetImageInput(): void {
    if (this.imageInput?.nativeElement) {
      this.imageInput.nativeElement.value = '';
    }
  }

  updateEmployee(): void {
    if (!this.employeeId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_employee_id'));
      return;
    }

    // التحقق من صحة النموذج
    if (this.editForm?.invalid) {
      this.markFormGroupTouched();
      this.toastr.error(this.translate.instant('MENU.VALIDATION.fill_all_required_fields'));
      return;
    }

    this.isLoading = true;

    const formData = new FormData();
    formData.append('name', this.product.name);
    formData.append('email', this.product.email);
    formData.append('identity_number', this.product.identity_number || '');
    formData.append('job_title_id', this.product.job_title_id || '');
    formData.append('phone', this.product.phone || '');
    formData.append('city_id', this.product.city_id || '');
    formData.append('nationality_id', this.product.nationality_id || '');

    // ✅ إضافة الصورة فقط إذا تم تحميل صورة جديدة
    if (this.selectedFile instanceof File) {
      formData.append('image', this.selectedFile);
    } else if (!this.product.image && this.originalImage) {
      // إذا تمت إزالة الصورة
      formData.append('remove_image', 'true');
    }

    console.log('🔄 Updating employee with data:', {
      name: this.product.name,
      email: this.product.email,
      nationality_id: this.product.nationality_id,
      city_id: this.product.city_id,
      job_title_id: this.product.job_title_id
    });

    this.apiService.editEmployee(this.employeeId, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Employee updated successfully:', response);
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.employee_updated_successfully'));
        this.router.navigate(['/employees']);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
        this.handleError(err);
        this.isLoading = false;
      }
    });
  }

  // دالة لتحديد جميع الحقول التي تم لمسها (للعرض الصحيح لأخطاء التحقق)
  private markFormGroupTouched(): void {
    if (this.editForm?.controls) {
      Object.keys(this.editForm.controls).forEach(key => {
        const control = this.editForm.controls[key];
        control.markAsTouched();
      });
    }
  }

  private handleError(err: any): void {
    let errorMessage = this.translate.instant('MENU.DASHBOARD.failed_to_update_employee');
    
    if (err.error?.message) {
      errorMessage = err.error.message;
    } else if (err.error?.errors) {
      const errors = err.error.errors;
      const errorMessages: string[] = [];
      Object.values(errors).forEach((error: any) => {
        if (Array.isArray(error)) {
          errorMessages.push(...error);
        } else {
          errorMessages.push(error);
        }
      });
      errorMessage = errorMessages.join(', ');
    }
    
    this.toastr.error(errorMessage);
  }

  // 🔥 فانكشن Cancel جديدة
  cancel(): void {
    // عرض تأكيد قبل الإلغاء
    const confirmMessage = this.translate.instant('MENU.DASHBOARD.confirm_cancel');
    if (confirm(confirmMessage)) {
      this.router.navigate(['/employees']);
    }
  }
}